module.exports = "/assets/1482701275bef8aae58ff0fb1e61db97.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/2D.png
// module id = 979
// module chunks = 0